import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/professional-codes')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/professionals/codes' });
  },
});
